import { pageToDataLayerInfo } from '../utils';
import { addToDataLayer, type DataLayerEvent } from '..';

export type FilterUpdateEventType = {
  facets: Array<Excite.Esales.FacetApiModel>;
  action?: 'add' | 'remove' | 'change' | 'reset';
  facet?: Excite.Esales.FacetApiModel;
  value?: Excite.Esales.RangeApiModel | string;
};

function isRangeApiModel(value: any): value is Excite.Esales.RangeApiModel {
  return value && value.minSelected !== undefined;
}

function formatSelectedFacetValues(facet: Excite.Esales.FacetApiModel) {
  if (facet.isRange) {
    if (facet.range.minSelected === facet.range.min && facet.range.maxSelected === facet.range.max) {
      return '';
    }
    return facet.range?.minSelected + '-' + facet.range?.maxSelected;
  }
  return (
    '[' +
    facet.values
      .filter(x => x.selected)
      .map(x => x.text)
      .sort((a, b) => (a < b ? -1 : 1))
      .join(', ') +
    ']'
  );
}

export function addFilterInteractionEventToDataLayer(data: FilterUpdateEventType) {
  const { facets, facet, value, action } = data;
  let filter_action = 'change';
  if (facet && value && !isRangeApiModel(value) && value !== 'true' && value !== 'false') {
    const found = facet.values.find(x => x.text === value);
    filter_action = found?.selected ? 'add' : 'remove';
  }

  let filter_value = value;
  if (value && isRangeApiModel(value)) {
    filter_value = value.minSelected + '-' + value.maxSelected;
  }

  const ga4Event: DataLayerEvent = {
    event: 'filter_interaction',
    event_info: {
      filter_action: action ?? filter_action,
      filter_type: facet?.attribute,
      filter_value: filter_value,
      ...pageToDataLayerInfo(),
      filter_array: facets.map(x => ({
        filter_type: x.attribute,
        filter_value: formatSelectedFacetValues(x),
        number_of_filters: x.values.length,
      })),
    },
  };
  addToDataLayer(ga4Event);
}
